import React, { useEffect } from "react";
import CreateWorkOrder from "../../Components/CreateWorkOrder/CreateWorkOrder";
import { useDispatch, useSelector } from "react-redux";
import { getSingleTicket } from "../../Redux/Slices/SingleTicketSlice/SingleTicketSlice";
import { useParams } from "react-router-dom";
const CreateWorkOrderForm = () => {
  const dispatch = useDispatch();
  const { ticket_id } = useParams();
  const single_ticket = useSelector((state) => state.single_ticket);
  console.log(single_ticket, "single_ticket");
  useEffect(() => {
    dispatch(getSingleTicket(ticket_id));
    // dispatch(getInstallersListAction(state_id));
  }, []);
  return (
    <>
      <CreateWorkOrder />
    </>
  );
};

export default CreateWorkOrderForm;
